<template>
  <div class="table-responsive">
    <table class="table">
      <thead style="color: #7A7A7A">
      <slot name="thead"></slot>
      </thead>
      <tbody>
      <slot name="tbody"></slot>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'c-table',
};
</script>

<style lang="scss" scoped>
table {
  border-collapse: separate;
  border-spacing: 0 0.75rem;
}

th,
thead,
thead tr {
  border: none !important;
  color: black;
  text-align: center;
}

tr {
  margin-bottom: 0.75rem;
  background: #fff;
  border: 1px solid rgba(3, 147, 42, 0.08);
  box-sizing: border-box;
  border-radius: 6px;
  width: 100%;
}

tbody tr td {
  position: relative;
  padding: 0.5rem;
  font-weight: 500;
  text-align: center;
}

tbody tr td::before {
  content: "";
  display: block;
  height: 70%;
  width: 1px;
  background: #eaeaea;
  position: absolute;
  right: 0;
  top: 15%;
}

tbody tr td:last-child::before {
  display: none;
}

td {
  border-top: 1px solid rgba(3, 147, 42, 0.08);
  border-bottom: 1px solid rgba(3, 147, 42, 0.08);
}

td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-left: 1px solid rgba(3, 147, 42, 0.08);
}

td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-right: 1px solid rgba(3, 147, 42, 0.08);
}

td {
  color: rgba(82, 82, 82, 1);
  border-top: 1px solid rgba(3, 147, 42, 0.08);
  border-bottom: 1px solid rgba(3, 147, 42, 0.08);
  font-size: 0.875rem;
}

.cell-table {
  white-space: nowrap;
  padding: 0.75rem 1.5rem;
  color: rgba(122, 122, 122, 1);
  font-size: 1rem;
}

.cell-table i {
  margin: 0 0.5rem;
}

tr:hover {
  background: #dfdfdf;
}

.action-cell {
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}

.action-cell > div {
  display: flex;
  align-items: center;
}

.action-btn {
  cursor: pointer;
  transition: all 0.1s ease-in;
  margin: 0 0.25rem;
}

.action-btn:hover {
  transform: scale(1.2) translateY(2px);
}

.img {
  width: 77px;
  height: 55.5px;
  background: #d5d5dc;
  border-radius: 5px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.img img {
  width: 100%;
  height: auto;
}

</style>
